import React from 'react';
import { ShieldCheck, Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export const GuaranteeSection = () => {
  return <section className="py-12 md:py-20 bg-navy-950 border-y border-gold-500/30 relative overflow-hidden" data-id="element-125">
      {/* Background rays */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 blur-[100px] pointer-events-none rounded-full" data-id="element-126" />
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(212,175,55,0.1) 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-127" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-128">
        <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-129">
          {/* Seal with rays */}
          <div className="relative inline-flex items-center justify-center mb-5 md:mb-8" data-id="element-130">
            {/* Outer decorative ring */}
            <div className="absolute inset-0 w-full h-full" data-id="element-131">
              <div className="absolute inset-0 rounded-full border-2 border-gold-500/30 animate-pulse" data-id="element-132" />
            </div>
            {/* Stars around */}
            <Star className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-3 fill-gold-500 text-gold-500" data-id="element-133" />
            <Star className="absolute top-1/2 -translate-y-1/2 -left-1 w-3 h-3 fill-gold-500 text-gold-500" data-id="element-134" />
            <Star className="absolute top-1/2 -translate-y-1/2 -right-1 w-3 h-3 fill-gold-500 text-gold-500" data-id="element-135" />
            <Star className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-3 h-3 fill-gold-500 text-gold-500" data-id="element-136" />

            <div className="relative inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 border-4 border-gold-300 shadow-[0_0_40px_rgba(212,175,55,0.5)]" data-id="element-137">
              <div className="absolute inset-1 rounded-full border-2 border-navy-950/30" data-id="element-138" />
              <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-navy-950 relative z-10" strokeWidth={2.5} data-id="element-139" />
            </div>
          </div>

          <div className="inline-block bg-gold-500/10 border border-gold-500/40 text-gold-500 text-xs uppercase tracking-widest font-bold px-4 py-1 rounded-full mb-4" data-id="element-140">
            ✨ Garantía Total
          </div>

          <h2 className="text-3xl md:text-5xl font-bebas text-white mb-4 md:mb-6 text-glow-gold" data-id="element-141">
            GARANTÍA ARMADOR DE ÉLITE —{' '}
            <span className="text-gold-500" data-id="element-142">7 DÍAS</span>
          </h2>

          <div className="text-base md:text-xl text-gray-300 space-y-3 md:space-y-4 mb-6 md:mb-8 leading-relaxed" data-id="element-143">
            <p data-id="element-144">
              Abrís los 6 tomos. Revisás los 6 bonos. Los aplicás en tu
              entrenamiento si querés.
            </p>
            <p className="font-bold text-white text-lg md:text-2xl bg-gold-500/5 border border-gold-500/20 rounded-xl py-3 px-4 inline-block" data-id="element-145">
              Si en 7 días no es lo que esperabas:{' '}
              <span className="text-gold-500" data-id="element-146">Te devolvemos el 100%.</span>
            </p>
            <p className="text-gray-400" data-id="element-147">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          <p className="text-gray-400 italic text-sm md:text-base" data-id="element-148">
            La confianza que tenemos en Armador de Élite™ nos permite hacer esa
            promesa sin dudar. Más de 200 armadores de todo el país ya lo saben.
          </p>

          <div className="mt-5 md:mt-8 inline-flex items-center gap-2 bg-green-500/10 px-5 md:px-6 py-2 rounded-full border border-green-500/30 text-xs md:text-sm font-bold text-green-400" data-id="element-149">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-150" />
            Tasa de devoluciones menor al 1%
          </div>
        </FadeIn>
      </div>
    </section>;
};